/**
* 封禁账号详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 搜索条件 -->
		<div style="margin: 0 20px; display: flex; margin-top: 20px;">

			<el-input style="margin-left: 5px; margin-right: 10px;" placeholder="请输入内容" v-model="input1"
				label-width="60px">
				<template slot="prepend">用户ID</template>
			</el-input>

			<el-button style="margin-left: 5px;" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="输入添加白名单的用户ID"
				v-model="input2" label-width="60px">
				<template slot="prepend">用户ID</template>
			</el-input>

			<el-button style="margin-left: 5px;" type="primary" @click="add()">添加白名单</el-button>

		</div>


		<!-- 列表 -->
		<el-table :data="tableData" stripe border style="width: 100%; flex: 1; margin-top: 20px;" height="100%">
			<el-table-column type="index" :index="indexMethod" width="50" align="center"></el-table-column>
			<el-table-column prop="userId" label="用户ID" align="center" width="100"></el-table-column>

			<el-table-column prop="age" label="年龄" align="center" width="70"></el-table-column>

			<el-table-column label="性别" align="center" width="100">
				<template slot-scope="scope">
					<el-tag size="small"
						:style="{ backgroundColor: scope.row.sexBg, color: scope.row.sexColor, border: 'none' }">
						{{ scope.row.sexText }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="sexOrientation" label="性取向" align="center" width="100">
				<template slot-scope="scope">
					<el-tag size="mini" type="info" effect="plain">{{ scope.row.sexOrientation }}</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="attribute" label="属性" align="center" width="100">
				<template slot-scope="scope">
					<el-tag size="mini" type="warning" effect="dark">{{ scope.row.attribute }}</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="country" label="国家" align="center" width="80"></el-table-column>
			<el-table-column prop="phoneNumber" label="手机号码" align="center" width="150"></el-table-column>
			<el-table-column prop="status" label="状态" align="center"></el-table-column>

			<el-table-column label="操作" width="120" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="small"
						style="color: #F56C6C">移除白名单</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				input1: '', //搜素的用户ID
				input2: '', //添加白名单的用户ID
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //查询白名单列表
		},
		methods: {
			fetchData(pageNum, pageSize) { //查询白名单列表

				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input1.length > 0) { //用户id 精确查询
					requestData.userId = this.input1;
				}

				axios.post(this.$p_url + '/admin/getWhiteListUserListRes', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("查询白名单列表 数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据
							let list = response.data.data.list;

							// 核心逻辑：循环处理每一行的数据转换
							list.forEach(item => {
								// 1. 状态转换
								const statusMap = {
									"-3": "已注销",
									"0": "正常",
									"1": "禁言",
									"2": "封号(未处理)",
									"4": "封号(已处理)"
								};
								item.status = statusMap[item.status] || "未知";

								// 2. 性别展示逻辑 (根据你提供的色值)
								const sexMap = {
									1: {
										text: '男',
										bg: '#9BDFFC',
										color: '#02A1FC'
									},
									2: {
										text: '女',
										bg: '#FED7D7',
										color: '#FC5E5E'
									},
									3: {
										text: 'CD',
										bg: '#BEB5FC',
										color: '#4A418C'
									},
									4: {
										text: 'TS',
										bg: '#FBCE9A',
										color: '#FA8F14'
									}
								};
								const sInfo = sexMap[item.sex] || {
									text: '其他',
									bg: '#A7F8D8',
									color: '#0DBB76'
								};
								item.sexText = sInfo.text;
								item.sexBg = sInfo.bg;
								item.sexColor = sInfo.color;

								// 3. 性取向转换
								const orientMap = {
									1: "BIS",
									2: "HETERO",
									3: "GAY",
									4: "LES"
								};
								item.sexOrientation = orientMap[item.sexOrientation] || "--";

								// 4. 属性转换
								const attrMap = {
									1: "SADO",
									2: "MASO",
									3: "DOM",
									4: "SUB",
									5: "SWITCH"
								};
								item.attribute = attrMap[item.attribute] || "--";
							});

							this.tableData = list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			add() { //添加白名单
				if (this.input2.length > 0) { //设备id 精确查询
					this.loadingData = true;

					const requestData = {}; //传递的参数
					requestData.userId = this.input2;

					axios.post(this.$p_url + '/admin/addUserToWhiteList', requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("添加白名单 数据返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.fetchData(1, this.pageSize);
							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			deviceId(id) { //移除白名单
				this.loadingData = true;

				const requestData = {}; //传递的参数
				requestData.userId = id;

				axios.post(this.$p_url + '/admin/removeToWhiteList', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("解封账号 返回的值：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.fetchData(1, this.pageSize);
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("请求失败：" + error);
					});

			},
			querySimCard(index) { //移除白名单
				console.log('移除白名单', this.tableData[index].userId);
				this.deviceId(this.tableData[index].userId);
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			//...
		},
		//...
	}
</script>

<style>
	.container {
		display: flex;
		padding: 0px 10px;
	}

	.box {
		flex: 1;
		padding: 15px;
		width: 180px;
		height: 60px;
		margin: 10px;
		border-radius: 20px;
		/* 防止文本溢出 */
		overflow: hidden;
	}
</style>